import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import {useTokensStore} from "@/store/tokens.store";
import { PieChart } from "echarts/charts";
import VChart from "vue-echarts";
import { use } from "echarts/core";
import { SVGRenderer } from "echarts/renderers";
import { TitleComponent, TooltipComponent, LegendComponent } from 'echarts/components';
import { createTokenomicsChartData } from "@/charts/dashboard";
import ShadowedSvgChart from "../commons/ShadowedSvgChart.vue";
import CoinAmount from "../commons/CoinAmount.vue";
import { useConfigurationStore } from "@/store/configuration.store";
import { BigDecimal } from "@/models/store/big.decimal";
import PercentsView from "@/components/commons/PercentsView.vue";
import {BigIntWrapper} from "@/models/store/common";


export default /*#__PURE__*/_defineComponent({
  __name: 'TokenomicsDashboard',
  setup(__props, { expose: __expose }) {
  __expose();


use([
  SVGRenderer,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent
]);

const tokensStore = useTokensStore();

const boundedPercentage = computed(() => {
  return tokensStore.getBoundedPercentage;
});
const unboundedPercentage = computed(() => {
  return tokensStore.getUnboundedPercentage;
});

const unboundingPercentage = computed(() => {
  return tokensStore.getUnboundingPercentage;
});

const bounded = computed((): number | BigDecimal => {
  return useConfigurationStore().config.getConvertedAmount(tokensStore.getTotalBonded);
});

const unBounded = computed((): number | BigDecimal => {
  return useConfigurationStore().config.getConvertedAmount(tokensStore.getTotalUnbonded);
});

const unBounding = computed((): number | BigDecimal => {
  return useConfigurationStore().config.getConvertedAmount(tokensStore.getTotalUnbonding);
});

const totalSupply = computed((): number | BigDecimal => {
  return useConfigurationStore().config.getConvertedAmount(tokensStore.getTotalSupply.amount);
});

const option = computed(() => {
  return createTokenomicsChartData(bounded.value, unBounded.value, unBounding.value, totalSupply.value);
});


const __returned__ = { tokensStore, boundedPercentage, unboundedPercentage, unboundingPercentage, bounded, unBounded, unBounding, totalSupply, option, get VChart() { return VChart }, ShadowedSvgChart, CoinAmount, PercentsView, get BigIntWrapper() { return BigIntWrapper } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})